
import PropTypes from 'prop-types';
import NewNavbar from './NewNavbar';

const Layout = ({ children }) => {
  return (
    <div>
      <NewNavbar />
      <div className="container mx-auto mt-10 p-4">
        {children}
      </div>
    </div>
  );
};
Layout.propTypes = {
    children: PropTypes.node.isRequired,
  }; 
  

export default Layout;
